// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2m9FL","title":"Header_title__2xThM","headerActions":"Header_headerActions__39_iS"};